import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/',
    headers: {
      'Content-Type': 'application/json'
    }
  }),
  endpoints: (builder) => ({
    register: builder.mutation({
      query: ({ email, password, first_name, last_name }) => ({
        url: 'api/v2/storefront/register',
        method: 'POST',
        body: {
          user: { email, password, password_confirmation: password, first_name, last_name }
        }
      })
    }),
    resendConfirmation: builder.mutation({
      query: (email) => ({
        url: 'api/v2/storefront/resend_confirmation',
        method: 'POST',
        body: { email }
      })
    }),
    confirmUser: builder.mutation({
      query: ({ email, code }) => ({
        url: 'api/v2/storefront/confirm',
        method: 'POST',
        body: { email, code }
      })
    }),
    getNewToken: builder.mutation({
      query: (formData) => ({
        url: 'spree_oauth/token',
        method: 'POST',
        body: formData,
      }),
    }),
    refreshToken: builder.mutation({
      query: (refresh_token) => ({
        url: 'spree_oauth/token',
        method: 'POST',
        body: {
          grant_type: 'refresh_token',
          refresh_token,
        },
      }),
    }),
    forgotPassword: builder.mutation({
      query: (email) => ({
        url: 'api/v2/storefront/passwords',
        method: 'POST',
        body: { email }
      }),
    }),
    resetPassword: builder.mutation({
      query: ({ token, password, password_confirmation }) => ({
        url: 'api/v2/storefront/passwords',
        method: 'PUT',
        body: {
          reset_password_token: token,
          password,
          password_confirmation
        },
      }),
    }),
    validateResetToken: builder.query({
      query: (token) => ({
        url: 'api/v2/storefront/passwords/validate',
        method: 'POST',
        body: { reset_password_token: token },
      }),
    })
  }),
});

export const {
  useGetNewTokenMutation,
  useRefreshTokenMutation,
  useRegisterMutation,
  useResendConfirmationMutation,
  useConfirmUserMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useValidateResetTokenQuery
} = authApi;